import { useAccount } from "../component/context/AccountProvider";
export const USER_TYPE = {
  INDIVIDUAL: "individual",
  ORGANIZATION: "organisation",
};
const useLoggedInUserType = () => {
const { userDetails } = useAccount() || {};

console.log("useAccount result =", useAccount());


  if (userDetails?.user_type === USER_TYPE.ORGANIZATION) {
    return USER_TYPE.ORGANIZATION;
  } else {
    return USER_TYPE.INDIVIDUAL;
  }
  // console.log(userDetails, "userDetails data");
};

export default useLoggedInUserType;
